import cookies from 'libs/cookie';
import cacheService from 'libs/localStorageCacheService';
import sessionStorageService from 'libs/sessionStorageService';

const PROFILE_FIRST_INTENDED_URL = 'profile-first-intended-url';
const REQUIRED_FORMS_SKIPPED_SESSION = 'required-forms-skipped-session';

const getSessionKey = (): string | undefined => cookies.get('auth')?.tokens?.expiry;

export const saveFirstIntendedUrl = (path: string) => {
  if (!sessionStorageService.has(PROFILE_FIRST_INTENDED_URL)) {
    sessionStorageService.set(PROFILE_FIRST_INTENDED_URL, path);
  }
};

export const consumeFirstIntendedUrl = (): string | null => {
  const path = sessionStorageService.get(PROFILE_FIRST_INTENDED_URL);
  if (path) sessionStorageService.remove(PROFILE_FIRST_INTENDED_URL);
  return path;
};

export const saveSkippedRequiredForms = () => {
  const sessionKey = getSessionKey();
  if (sessionKey) cacheService.setData(REQUIRED_FORMS_SKIPPED_SESSION, sessionKey);
};

export const hasSkippedRequiredForms = () => {
  const sessionKey = getSessionKey();
  return !!sessionKey && cacheService.getData(REQUIRED_FORMS_SKIPPED_SESSION) === sessionKey;
};

export const clearRequiredFormsStorage = () => {
  cacheService.removeData(REQUIRED_FORMS_SKIPPED_SESSION);
  sessionStorageService.remove(PROFILE_FIRST_INTENDED_URL);
};
